import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const CAPABILITIES = [
  {
    number: "01",
    title: "Strategic Advisory & M&A",
    href: "/strategic-advisory",
    description:
      "Acquisitions, disposals, ownership transitions, mergers and strategic transactions for shareholders, investors and business owners.",
  },
  {
    number: "02",
    title: "Private Capital Advisory",
    href: "/private-capital",
    description:
      "Capital strategies, partnerships, acquisitions and investment mandates with private equity sponsors, investment managers and institutional investors.",
  },
  {
    number: "03",
    title: "Family Office Advisory",
    href: "/family-office-advisory",
    description:
      "Independent, long-term strategic support for wealthy families: direct investment origination, acquisition strategy and asset reviews.",
  },
  {
    number: "04",
    title: "Sports Investment Advisory",
    href: "/sports-investments",
    description:
      "Ownership transactions, strategic investments and capital partnerships across professional sport, with a focus on professional football.",
  },
  {
    number: "05",
    title: "Real Assets & Special Situations",
    href: "/sectors",
    description:
      "Hotels, major property portfolios, commercial real estate, aviation, infrastructure and complex ownership situations.",
  },
  {
    number: "06",
    title: "Principal Investments",
    href: "/#investments",
    description:
      "Selective direct investments and co-investments where the firm has the appropriate capital resources and structures.",
  },
];

export const CoreExpertise = () => (
  <section id="capabilities" data-testid="expertise-section" className="relative py-28 lg:py-40 bg-[#FFFFFF] border-y border-[#E3E0D8]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <Eyebrow>Core Capabilities</Eyebrow>
          <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
            Six disciplines. <span className="italic">One standard.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 lg:mt-24 border-t border-[#E3E0D8]">
        {CAPABILITIES.map((item, i) => (
          <Reveal key={item.number} delay={i * 0.05}>
            <Link
              to={item.href}
              data-testid={`expertise-card-${i}`}
              className="group relative grid lg:grid-cols-12 gap-3 lg:gap-8 items-start py-9 lg:py-12 px-2 lg:px-8 border-b border-[#E3E0D8] transition-[background-color] duration-500 hover:bg-[#F6F4F0]"
            >
              <span className="absolute left-0 top-0 h-full w-[2px] bg-[#1F1E1B] scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />

              <div className="lg:col-span-1">
                <span className="font-sans text-[11px] tracking-[0.24em] text-[#6E6A61] group-hover:text-[#1F1E1B] transition-colors duration-500">
                  {item.number}
                </span>
              </div>

              <div className="lg:col-span-9">
                <h3 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight text-[#1F1E1B]">
                  {item.title}
                </h3>
                <p className="mt-3 max-w-2xl text-sm sm:text-base leading-relaxed text-[#6E6A61]">
                  {item.description}
                </p>
              </div>

              <div className="hidden lg:flex lg:col-span-2 justify-end">
                <span className="flex items-center justify-center w-12 h-12 border border-[#E3E0D8] text-[#6E6A61] group-hover:border-[#1F1E1B] group-hover:text-[#1F1E1B] transition-[border-color,color,transform] duration-500 group-hover:translate-x-1 group-hover:-translate-y-1">
                  <ArrowUpRight size={18} strokeWidth={1.5} />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
